import { render, staticRenderFns } from "./consultAiList.vue?vue&type=template&id=3b752191&scoped=true"
import script from "./consultAiList.vue?vue&type=script&lang=js"
export * from "./consultAiList.vue?vue&type=script&lang=js"
import style0 from "./consultAiList.vue?vue&type=style&index=0&id=3b752191&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b752191",
  null
  
)

export default component.exports